<mat-accordion>
  @for (faq of faqs; track $index) {
    <mat-expansion-panel
      (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>{{ faq.Question }}</mat-panel-title>
        <!-- <mat-panel-description>
                Currently I am {{ panelOpenState() ? "open" : "closed" }}
            </mat-panel-description> -->
      </mat-expansion-panel-header>
      <app-inner-html [html]="faq.Answer"></app-inner-html>
    </mat-expansion-panel>
  }
</mat-accordion>
